/**
 * The chrome a box being edited keeps its session through. A press that
 * lands inside any of these is the user working the box, not leaving it:
 * the toolbar (with its popovers), a modal's backdrop, and a body-portaled
 * flyout — which sits outside the toolbar's subtree and, by the time the
 * click reaches `document`, is often already unmounted, so the marker has
 * to be on the flyout element itself for `closest()` to find it on the
 * detached target.
 */
export const EDITOR_EDIT_CHROME_SELECTORS = [
  '[data-editor-text-toolbar]',
  '[data-editor-text-modal-backdrop]',
  '[data-editor-text-flyout]',
] as const

export const EDITOR_EDIT_CHROME_SELECTOR =
  EDITOR_EDIT_CHROME_SELECTORS.join(', ')
